module.exports = __webpack_public_path__ + "media/images/product/p_e-c4159f6ea672f038229a08301fb453c7.png";